import { useQuery } from '@tanstack/react-query';
import useNotiStack from '../useNotiStack';
import { getUserList, handleResponse } from '../../config/apisauce';
import useStore from '../../states/store';

export const useCollabCreators = (key, params) => {
  const { error } = useNotiStack();
  const [, { openLoader, closeLoader }] = useStore();
  return useQuery({
    queryKey: [`user-list-${key}`],
    queryFn: async () => {
      openLoader();
      const response = await getUserList(params);
      closeLoader();
      return handleResponse(response);
    },
    staleTime: 5 * 60 * 1000, // 5 minutes (data remains fresh)
    cacheTime: 10 * 60 * 1000, // 10 minutes (data stays in cache)
    onError: (err) => {
      closeLoader();
      error(err?.message || err.problem);
    },
    onSettled: () => {
      closeLoader();
    },
    retry: false,
    refetchOnWindowFocus: false,
  });
};